import gql from 'graphql-tag'
import { Query } from '@apollo/client/react/components'
import LinearProgress from '@material-ui/core/LinearProgress'
import Error from '@components/error'
import FeaturedCourse from './featured-course'

const QUERY = gql`
query Facility($id: String!) {
  facility(facility_id: $id) {
    facility_name
    city
    state
    zip
    photo_facility
    facility_id
  }
}
`

export default function FeaturedCourseWithData(props) {
  return (
    <Query query={QUERY} variables={props} context={{ clientName: 'pga-algolia' }}>
      {({
        loading, error, data,
      }) => {
        if (error) return <Error error={error} />
        if (loading) return <LinearProgress color="secondary" />
        const response = data.facility
        return (
          <FeaturedCourse {...props} {...response} />
        )
      }}
    </Query>
  )
}
